import type { IconProps } from './types';

export const Play = ({ size, ...props }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30" fill="none" {...props}>
    <path
      d="M25.151 12.2778C26.8617 13.2654 26.8617 15.7346 25.151 16.7222L11.1984 24.7778C9.4877 25.7654 7.34936 24.5309 7.34936 22.5556L7.34937 6.44444C7.34937 4.46913 9.4877 3.23457 11.1984 4.22222L25.151 12.2778Z"
      fill="currentColor"
    />
  </svg>
);
